import { Slot } from "./../../services/slot";

export const state = {
  errors: null,
  doctors: [],
  units: [],
  hasSlots: false,
  isLoading: false,
  creatingSchedule: false,
  slotsRequested: false,
  slotsRequestedDoctorId: "",
  timeSuggestion: ""
};

export const mutations = {
  SET_IS_LOADING(state, payload) {
    state.isLoading = payload;
  },
  SET_HAS_SLOTS(state, payload) {
    state.hasSlots = payload;
  },
  SET_CREATING_SCHEDULE(state, payload) {
    state.creatingSchedule = payload;
  },
  SET_DOCTORS(state, payload) {
    state.doctors = payload;
  },
  SET_UNITS(state, payload) {
    state.units = payload;
  },
  SET_ERRORS(state, payload) {
    state.errors = payload;
  },
  SET_SLOTS_REQUESTED(state, payload) {
    state.slotsRequested = payload;
  },
  SET_SLOTS_REQUESTED_DOCTOR_ID(state, payload) {
    state.slotsRequestedDoctorId = payload;
  },
  SET_TIME_SUGGESTION(state, payload) {
    state.timeSuggestion = payload;
  }
};

export const getters = {
  errors(state) {
    return state.errors;
  },
  hasSlots(state) {
    return state.hasSlots;
  },
  doctors(state) {
    return state.doctors;
  },
  units(state) {
    return state.units;
  },
  isLoading(state) {
    return state.isLoading;
  },
  slotsRequested(state) {
    return state.slotsRequested;
  },
  slotsRequestedDoctorId(state) {
    return state.slotsRequestedDoctorId;
  },
  timeSuggestion(state) {
    return state.timeSuggestion;
  }
};

export const actions = {
  createSlot({}, { payload }) {
    return Slot.create({ slot_config: payload });
  },
  simpleCreate({}, payload) {
    return Slot.simpleCreate(payload);
  },
  deleteSlot({}, query) {
    return Slot.delete(query);
  },
  getConfig({}, query) {
    return Slot.getConfig(query);
  },
  async getDoctors({ commit }) {
    try {
      commit("SET_IS_LOADING", true);
      const response = await Slot.getDoctors();
      commit("SET_DOCTORS", response.data);
      return response;
    } catch (error) {
      commit("SET_ERRORS", error);
    } finally {
      commit("SET_IS_LOADING", false);
    }
  },
  async getUnits({ commit }) {
    try {
      commit("SET_IS_LOADING", true);
      const response = await Slot.getUnits();
      commit("SET_UNITS", response.data);
      return response;
    } catch (error) {
      commit("SET_ERRORS", error);
    } finally {
      commit("SET_IS_LOADING", false);
    }
  },
  setSlotsRequested({ commit }, payload) {
    commit("SET_SLOTS_REQUESTED", payload);
  },
  setSlotsRequestedDoctorId({ commit }, payload) {
    commit("SET_SLOTS_REQUESTED_DOCTOR_ID", payload);
  },
  setTimeSuggestion({ commit }, payload) {
    commit("SET_TIME_SUGGESTION", payload);
  },
  createTimeSuggestion({}, payload) {
    return Slot.timeSuggestion(payload);
  }
};
